const en = {
	acceptRules: 'Accept the terms.',
	activityType: 'Activity type',
	cancel: 'Cancel',
	clear: 'Clear',
	columns: 'Columns',
	contractFile: 'Contract File',
	date: 'Date',
	dataAndTime: 'Date and Time',
	dateIsNotEntered: 'Date is not entered',
	delete: 'Delete',
	download: 'Download',
	downloadExcelNotice: 'Note that the downloaded excel would contain the records you are viewing.',
	failedToGetInformation: 'Failed to get Information',
	female: 'Female',
	fileInvalidSizeDescription: 'File size must not be bigger than {{field}} MB.',
	fileInvalidType: 'File type is not valid',
	fileInvalidTypeDescription: 'File type must be {{field}}',
	gender: 'Gender',
	getExcel: 'Get excel',
	ip: 'IP',
	male: 'Male',
	name: 'Name',
	off: 'Off',
	ok: 'OK',
	on: 'ON',
	rial: 'Rials',
	status: 'Status',
	successful: 'Successful',
	time: 'Time',
	to: 'to',
	unSuccessful: 'Unsuccessful',
	uploadServiceNotFound: 'Upload Service Not Found!',
	view: 'View',
	yourActivityReport: 'Your Activity Report',
	rial: 'Rial',
	toman: 'Toman',
	doller: 'Doller',
};
export default en;
